import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
import { Reveal, SectionHeading } from '../Reveal';
import { CONSULTATION_INCLUDES } from '../../data/content';

const IMG = '/raaj.jpg';

const Consultation = () => (
  <section className="bg-white py-24 md:py-32" data-testid="consultation-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="overflow-hidden rounded-3xl bg-navy shadow-card-hover">
        <div className="grid items-center lg:grid-cols-2">
          <div className="relative h-72 overflow-hidden lg:h-full lg:min-h-[540px]">
            <motion.img
              initial={{ scale: 1.12 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
              src={IMG}
              alt="Raaj — Founder & Career Guide, CareerWithRaaj"
              className="absolute inset-0 h-full w-full object-cover object-top"
              data-testid="consultation-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 rounded-2xl border border-white/30 bg-white/90 px-5 py-3 shadow-card-hover backdrop-blur-xl" data-testid="consultation-guide-badge">
              <p className="font-display text-sm font-bold text-navy">Raaj</p>
              <p className="text-[11px] font-semibold uppercase tracking-wider text-coral">Founder & Career Guide</p>
            </div>
          </div>

          <div className="p-8 md:p-14">
            <SectionHeading
              dark
              index="06"
              overline="Consultation"
              title="Need Personalised Career Guidance?"
              description="Every student and professional is different. Get one-to-one guidance to understand your options and create a practical career plan."
            />
            <ul className="mt-8 grid gap-3 sm:grid-cols-2">
              {CONSULTATION_INCLUDES.map((item, i) => (
                <Reveal key={item} delay={0.06 * i}>
                  <li className="flex items-center gap-3 text-sm font-medium text-white/85">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-coral/20">
                      <Check className="h-3.5 w-3.5 text-coral" />
                    </span>
                    {item}
                  </li>
                </Reveal>
              ))}
            </ul>
            <Reveal delay={0.25}>
              <div className="mt-10 flex flex-col items-start gap-4">
                <Link
                  to="/book-consultation"
                  data-testid="consultation-book-cta"
                  className="inline-flex items-center gap-2 rounded-full bg-coral px-8 py-4 text-base font-semibold text-white transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-coral-deep"
                >
                  Book a Consultation <ArrowRight className="h-4 w-4" />
                </Link>
                <p className="rounded-lg border border-white/15 bg-white/5 px-4 py-2.5 text-xs text-white/60" data-testid="calendar-booking-note">
                  Choose your package and pay — time selection unlocks right after.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Consultation;
